'use strict';

import $ from 'jquery';
import 'jquery-match-height';

export default class ShareThoughtsForm {
  constructor() {

    if($('.share-thoughts-form').length) {
      $('.scfSectionContent div > span').matchHeight({
          byRow: true,
          property: 'height'
      });
    }
  }
}
